import CircleStyleTextBox from '../circleStyleTextBox/circleStyleTextBox';
import DOMPurify from 'dompurify';
import styles from './light.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
gsap.registerPlugin(ScrollTrigger);

const Light = ({ m2sText }) => {
  useEffect(() => {
    // gsap.to(`.${styles.img2}`, {
    //   scrollTrigger: {
    //     trigger: `.${styles.ctn}`,
    //     start: 'top center',
    //     toggleActions: 'play complete none reverse',
    //   },
    //   opacity: 1,
    // });

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: `.${styles.imgBox}`,
        start: 'top 20%',
        toggleActions: 'play complete none reverse',
      },
    });

    tl.to(`.${styles.img2}`, {
      opacity: 1,
    });

    tl.to(
      `.${styles.lightMask}`,
      {
        '--m2s-light-mask-point-1': '0%',
        '--m2s-light-mask-point-2': '0%',
      },
      0.2,
    );

    // let tl2 = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: `.${styles.ctn}`,
    //     start: 'top top',
    //     end:"200%",
    //     pin: true,
    //     scrub:1.5
    //   },
    // });

    // tl2.to(`.${styles.imgBox}`,{
    //   y:-50,
    //   duration:2
    // })

    // tl2.to(`.${styles.textBox}`,{
    //   y:-50,
    //   duration:2
    // },0)

    // tl2.to(`.${styles.imgBox}`,{
    //   y:-100,
    //   opacity:0,
    //   duration:2
    // },2)

    // tl2.to(`.${styles.textBox}`,{
    //   y:-100,
    //   opacity:0,
    //   duration:2
    // },2)

    // tl2.to(`.${styles.mainContent}`,{
    //   opacity:0,
    //   duration:4
    // },3)
  });
  return (
    // <div className={`${styles.ctn} m2s-section`}>
    //   <div className={styles.mainContent}>
    //     <div className={styles.imgBox}>
    //       <img
    //         src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-2-1.jpg"
    //         alt=""
    //         className={styles.img}
    //       />

    //       <img
    //         src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-2-2.jpg"
    //         alt=""
    //         className={styles.img2}
    //       />
    //     </div>

    //     <CircleStyleTextBox className={styles.textBox}>
    //       <div className={styles.lightMask}></div>
    //       <div>
    //         <h2
    //           dangerouslySetInnerHTML={{
    //             __html: DOMPurify.sanitize(m2sText['text7']),
    //           }}
    //         ></h2>
    //         <h5
    //           dangerouslySetInnerHTML={{
    //             __html: DOMPurify.sanitize(m2sText['text8']),
    //           }}
    //         ></h5>
    //         <div className={styles.lightParamsBox}>
    //           <div>
    //             <h6>{m2sText['text9']}</h6>
    //             <h3>
    //               1000<h5>lumen</h5>
    //             </h3>
    //           </div>

    //           <div className={styles.line}></div>
    //           <div>
    //             <h6>{m2sText['text10']}</h6>
    //             <h3>
    //               90<h5>+</h5>
    //             </h3>
    //           </div>
    //           <div className={styles.line}></div>
    //           <div>
    //             <h6>{m2sText['text11']}</h6>
    //             <h3>
    //               5500<h5>K</h5>
    //             </h3>
    //           </div>
    //         </div>
    //       </div>
    //     </CircleStyleTextBox>
    //   </div>

    //   <video
    //           autoPlay
    //           loop
    //           playsInline
    //           muted
    //     className={styles.lightVideo}
    //     src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-video-light.mp4"
    //   ></video>
    // </div>

    <div className={`${styles.ctn} m2s-section`}>
      <div className={styles.lightSection1}>
        <div className={styles.imgBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-2-1.jpg"
            alt=""
            className={styles.img}
          />

          <img
            src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-device-2-2.jpg"
            alt=""
            className={styles.img2}
          />
        </div>

        <CircleStyleTextBox className={styles.textBox}>
          <div className={styles.lightMask}></div>
          <div>
            <h2
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text7']),
              }}
            ></h2>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(m2sText['text8']),
              }}
            ></h5>
          </div>
        </CircleStyleTextBox>
      </div>

      <div className={styles.lightSection2}>
        <div className={styles.lightParamsBox}>
          <div>
            <h6>{m2sText['text9']}</h6>
            <h3>
              1000<h5>lumens</h5>
            </h3>
          </div>

          <div className={styles.line}></div>
          <div>
            <h6>{m2sText['text10']}</h6>
            <h3>
              90<h5>+</h5>
            </h3>
          </div>
          <div className={styles.line}></div>
          <div>
            <h6>{m2sText['text11']}</h6>
            <h3>
              5500<h5>K</h5>
            </h3>
          </div>
        </div>
        <video
          autoPlay
          loop
          playsInline
          muted
          className={styles.lightVideo}
          src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-video-light.mp4"
        ></video>
      </div>
    </div>
  );
};

export default Light;
